import {html as _} from "lit-html";
import {WARNING} from "@kta20-ui-base/comps/resources/icons";

//language=HTML
export default (message:string)=> _`
    <div style=" position:absolute; top:0;left:0;right:0;bottom:0; width: 50%; height: 30%; margin: auto; text-align: center; overflow:visible">
        <ion-icon color="light" style="font-size: 64px" src="data:image/svg+xml;utf8,${WARNING}"></ion-icon>
        <ion-text color="medium">
            <h5>${message || '[no-items]'}</h5>
        </ion-text>
    </div>
`;